import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, of } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { DdcLoggerService } from '../log/ddc-logger.service'

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_followers_page(page: number, pageSize: number): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.FOLLOWERS}?page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'FOLLOWERS | get_followers_page | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_following_page(page: number, pageSize: number): any {
    this.logger.info('FOLLOWING | get_following_page | page: ' + page + ' | pageSize: ' + pageSize)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.FOLLOWING}?page=${page}&pageSize=${pageSize}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'FOLLOWING | get_following_page | catchError | errorMessage: ' + errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  command(username: string, command: string): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    const userData = {
      username: username,
      command: command,
    }

    return this.http
      .post(`${Backend.HOST_CONTAINER + Backend.FOLLOW_COMMAND}`, userData, httpOptions)
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error('FOLLOWERS | command | catchError | errorMessage: ' + errorMessage)
          return of(errorMessage)
        }),
      )
  }

  get_searched_followers(target: string): any {
    this.logger.info('RELATIONSHIP_SEARCH | get_searched_followers | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.RELATIONSHIP_SEARCH}?follower=${target}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'RELATIONSHIP_SEARCH | get_searched_followers | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }

  get_searched_following(target: string): any {
    this.logger.info('RELATIONSHIP_SEARCH | get_searched_following | target: ' + target)

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
    }

    return this.http
      .get(
        `${Backend.HOST_CONTAINER + Backend.RELATIONSHIP_SEARCH}?following=${target}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          return res
        }),
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'RELATIONSHIP_SEARCH | get_searched_following | catchError | errorMessage: ' +
              errorMessage,
          )
          return of(errorMessage)
        }),
      )
  }
}
